import { useSemaforoEscalamiento } from "../../../hooks/useAsistenciasSemaforo";

export const useGetServicios = () => {
  const { asistencias, loading, error } = useSemaforoEscalamiento();
  const serviciosEscalamiento = asistencias.filter(
    (asistencia) => asistencia.fechaEscalamientoAsignacion !== null
  );

  return { serviciosEscalamiento, loading, error };
};
